import React, { useEffect, useRef } from "react";
import useLatest from "../../../hooks/useLatest";
import { mapMachines } from "../hotseatModel";
import { createRoomFireball } from "./roomEngine";

// Sala Hot Seat en canvas 2D: la bola de fuego recorre las islas hasta que llega el resultado del
// servidor, se detiene frente a la máquina ganadora y la cámara hace zoom a ella.
// Las 20 posiciones son las mismas de HotSeatScene (representación visual, no ubicación física).
// Recorrido de espera de 10 s (se alarga si el servidor tarda): con la aproximación, el zoom y el fundido el sorteo completo queda en unos 14,7 s.
const TOUR_MS = 10000;

export default function CasinoFireballScene({ outcome, participants, durationMs, onReady, onComplete, onPhase, onFallback }) {
  const canvas = useRef(null);
  const engine = useRef(null);
  const latest = useLatest({ outcome, participants, onReady, onComplete, onPhase, onFallback });

  useEffect(() => {
    const instance = createRoomFireball(canvas.current, {
      minMs: TOUR_MS,
      onReady: () => latest.current.onReady?.(),
      onComplete: (result) => latest.current.onComplete?.(result),
      onPhase: (phase) => latest.current.onPhase?.(phase),
      onError: () => latest.current.onFallback?.(),
    });
    engine.current = instance;
    return () => {
      instance.destroy();
      engine.current = null;
    };
  }, [durationMs, latest]);

  useEffect(() => {
    if (!outcome || !engine.current) return;
    const { winnerIndex } = mapMachines(latest.current.participants, outcome.winner);
    engine.current.setOutcome(outcome.winner ? winnerIndex : null);
  }, [outcome, latest]);

  return (
    <canvas
      ref={canvas}
      role="img"
      aria-label="Salón de máquinas tragamonedas; una bola de fuego busca la máquina ganadora"
      style={{ display: "block", width: "100%", height: "100%", objectFit: "cover" }}
    />
  );
}
